
















import Vue, { PropType } from 'vue'

import { Message as MessageInterface } from 'base/store/state.interface'
import Message from '../message/Message.vue'

export default Vue.extend({
  components: {
    Message
  },
  props: {
    replyParentMessage: {
      type: Object as PropType<MessageInterface | null>,
      default: null
    },
    messageToEdit: {
      type: Object as PropType<MessageInterface | null>,
      default: null
    }
  },
  data() {
    return {
      replyText: ''
    }
  },
  computed: {
    textareaRows(): number {
      const minRows = 1
      const maxRows = 15
      return Math.min(maxRows, Math.max(minRows, (this.replyText.match(/\n/g) || []).length + 1))
    },
    isReplyTextEmpty(): boolean {
      return this.replyText.replace(/\s/g, '').length > 0
    }
  },
  methods: {
    onReturnKeyDown(event: any) {
      if (event.shiftKey) {
        return
      }

      event.preventDefault()
      event.stopPropagation()

      this.clickAction()
    },
    clickAction() {
      if (this.messageToEdit) {
        this.$emit('updateMessage', this.messageToEdit, this.replyText)
        return
      }

      if (this.isReplyTextEmpty) {
        this.$emit('sendMessage', this.replyText)
        return
      }

      this.$emit('addAttachment')
    },
    clearReplyText() {
      this.replyText = ''
    },
    setReplyText(replyText: string) {
      this.replyText = replyText
    },
    focus() {
      this.$refs.textarea.focus()
    }
  }
})
